'use client';
import React from 'react';
import { Image } from '@ssv-website/web-ui';
interface IProps {
  tag: string;
  text: string;
  imgUrl: string;
  isMobile?: boolean;
  link?: string;
}
const CaseCard = ({ tag, text, imgUrl, isMobile, link }: IProps) => {
  const cs = isMobile ? mobile_class : desktop_class;
  const onLink = () => {
    if (!link) return;
    window.open(link);
  };
  return (
    <div
      className={`rounded-2xl overflow-hidden group relative flex flex-col cursor-pointer ${cs.box}`}
      onClick={onLink}
    >
      <Image
        src={imgUrl}
        alt=""
        className=" w-full pc:group-hover:scale-110 pc:transition-all pc:duration-700 object-cover"
        width={240}
        height={120}
      />

      <div className=" absolute top-0 left-0 w-full h-full flex flex-col justify-between">
        {tag ? (
          <div className="rounded-[1.3rem] m-2 bg-black/20 text-white text-xs font-400 w-20 h-8 flex items-center justify-center">
            {tag}
          </div>
        ) : (
          <div />
        )}
        <div
          className={`box-border text-white leading-6 font-400 bg-gradient-to-t to-white/0 from-black/60 ${cs.text}`}
        >
          {text}
        </div>
      </div>
    </div>
  );
};

export default CaseCard;
const desktop_class = {
  box: 'w-[28.56rem] max-h-[15rem] h-[22vh] mx-[0.87rem]',
  text: 'text-base p-5',
};
const mobile_class = {
  box: 'w-full aspect-[389/204]',
  text: 'text-xss p-3',
};
